export default "__VITE_ASSET__C45Ttck0__"